import { render } from "./DeleteTreeContractModal.vue?vue&type=template&id=b49e7dda"
import script from "./DeleteTreeContractModal.vue?vue&type=script&lang=js"
export * from "./DeleteTreeContractModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__